export interface PageViewEvent {
  page: string
  timestamp: string
}

const STORAGE_KEY = 'webinar_analytics'

export function trackPage(page: string): void {
  try {
    const existing = localStorage.getItem(STORAGE_KEY)
    const events: PageViewEvent[] = existing ? JSON.parse(existing) : []

    events.push({
      page,
      timestamp: new Date().toISOString(),
    })

    localStorage.setItem(STORAGE_KEY, JSON.stringify(events))
  } catch (error) {
    console.error('Error tracking page view:', error)
  }
}

export function getPageViews(): PageViewEvent[] {
  try {
    const existing = localStorage.getItem(STORAGE_KEY)
    return existing ? JSON.parse(existing) : []
  } catch (error) {
    console.error('Error getting page views:', error)
    return []
  }
}

export function getPageViewsInRange(
  startDate: Date,
  endDate: Date,
): PageViewEvent[] {
  const allEvents = getPageViews()

  // Set end date to end of day for inclusive filtering
  const endOfDay = new Date(endDate)
  endOfDay.setHours(23, 59, 59, 999)

  // Set start date to beginning of day
  const startOfDay = new Date(startDate)
  startOfDay.setHours(0, 0, 0, 0)

  return allEvents.filter((event) => {
    const eventDate = new Date(event.timestamp)
    return eventDate >= startOfDay && eventDate <= endOfDay
  })
}
